// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  width: 100%;
}

.container {
  display: flex;
  width: 100%;
  flex-direction: column;
  position: relative;
}

.arrow {
  transition: transform 0.3s ease;
  transform: rotate(0deg);
}
.arrow.open-select {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.calendar {
  display: none;
}
.calendar.show-calendar {
  min-width: 249px;
  display: flex;
  width: 100%;
  background-color: white;
  flex-direction: column;
  box-shadow: 0px 3px 6px rgba(14, 155, 213, 0.1019607843);
  border-radius: 6px;
  padding: 15px;
}

.header {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

.arrow-circle {
  width: 28px;
  height: 28px;
  border: 1px solid #4ED3C1;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: transparent;
}
.arrow-circle.previous-arrow {
  transform: rotate(90deg);
}
.arrow-circle.next-arrow {
  transform: rotate(-90deg);
}

.calendar {
  position: absolute;
  top: 48px;
  z-index: 100;
}`, "",{"version":3,"sources":["webpack://./projects/dnest-core-angular/src/lib/components/calendar/calendar.component.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,WAAA;AADJ;;AAIA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,+BAAA;EACA,uBAAA;AADJ;AAGI;EACI,yBAAA;EACA,+BAAA;AADR;;AAKA;EACI,aAAA;AAFJ;AAKI;EACI,gBAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,wDAAA;EACA,kBAAA;EACA,aAAA;AAHR;;AAQA;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AALJ;;AAQA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,6BAAA;AALJ;AAQI;EACI,wBAAA;AANR;AASI;EACI,yBAAA;AAPR;;AAYA;EACI,kBAAA;EACA,SAAA;EACA,YAAA;AATJ","sourcesContent":["@import '../../styles/mixins.scss';\n\n:host {\n    display: flex;\n    width: 100%;\n}\n\n.container {\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    position: relative;\n}\n\n.arrow {\n    transition: transform 0.3s ease;\n    transform: rotate(0deg);\n    \n    &.open-select {\n        transform: rotate(180deg);\n        transition: transform 0.3s ease;\n    }\n}\n\n.calendar {\n    display: none;\n    //@include generate-themes-styles(dnest-core-calendar);\n\n    &.show-calendar {\n        min-width: 249px;\n        display: flex;\n        width: 100%;\n        background-color: white;\n        flex-direction: column;\n        box-shadow: 0px 3px 6px #0E9BD51A;\n        border-radius: 6px;\n        padding: 15px;\n        //@include generate-themes-styles(dnest-core-calendar-show-calendar);\n    }\n}\n\n.header {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 15px;\n}\n\n.arrow-circle {\n    width: 28px;\n    height: 28px;\n    border: 1px solid #4ED3C1;\n    border-radius: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    background-color: transparent;\n    //@include generate-themes-styles(dnest-core-calendar-arrow-circle);\n\n    &.previous-arrow {\n        transform: rotate(90deg);\n    }\n    \n    &.next-arrow {\n        transform: rotate(-90deg);\n    }\n\n}\n\n.calendar {\n    position: absolute;\n    top: 48px;\n    z-index: 100;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
